module.exports = __webpack_public_path__ + "static/media/7x7GoodOptimized.9ad47a9d.png";